module.exports = __webpack_public_path__ + "img/logo-footer.d8d004dc.png";